import VideoPlayer from '../common/VideoPlayer/VideoPlayer';
import { buildLessonVideoTarget } from '../../utils/vdocipherMappers';

export default function LessonVideoPlayer({
  lesson,
  isLoggedIn,
  onRequireAuth,
  onRequireSubscription,
  onProgressSync,
  onComplete,
  onError,
}) {
  return (
    <VideoPlayer
      target={buildLessonVideoTarget(lesson)}
      isLoggedIn={isLoggedIn}
      onRequireAuth={onRequireAuth}
      onRequireSubscription={onRequireSubscription}
      onProgressSync={onProgressSync}
      onComplete={onComplete}
      onError={onError}
      emptyTitle="No lesson selected"
      emptyMessage="Choose a lesson from the playlist."
    />
  );
}
